import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

export const DepositsMain = () => {

	const deposits = useSelector((state: IState) => state.deposits)

	React.useEffect(
		() => {
			ws.send({ type: 'Deposits.Get' } as any)
		},
		[])
	
	return (
		<div className='depositMain'>
			<span className='pageTitle'>Deposits</span>
			<span className='pageBoxTitle'>Pending Fiat Deposits</span>
			<div>
				<table className='depositsTableMain'>
					<thead>
						<tr className='depositsTableHeaderRow'>
							<td className='depositsTableHeaderRowItem'>Deposit ID</td>
							<td className='depositsTableHeaderRowItem'>Date</td>
							<td className='depositsTableHeaderRowItem'>Coin</td>
							<td className='depositsTableHeaderRowItem'>Amount</td>
							<td className='depositsTableHeaderRowItem'>Bank Account</td>
							<td className='depositsTableHeaderRowItem'>Full Name</td>
							<td className='depositsTableHeaderRowItem'>Document ID Number</td>
							<td className='depositsTableHeaderRowItem'>Actions</td>
						</tr>
					</thead>
					<tbody>
						{deposits.map(m =>
							<tr className='depositsTableBodyRow' key={m.id}>
								<td className='depositsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.id), 6)}</td>
								<td className='depositsTableBodyRowItem'>{m.date ? new Date(m.date).toLocaleString('en-GB') : ''}</td>
								<td className='depositsTableBodyRowItem'>{m.coin}</td>
								<td className='depositsTableBodyRowItem'>{m.amount.toFixed(2)}</td>
								<td className='depositsTableBodyRowItem'>{m.bankAccount}</td>
								<td className='depositsTableBodyRowItem'>{m.fullName}</td>
								<td className='depositsTableBodyRowItem'>{m.docIdNumber}</td>
								<td className='depositsTableBodyRowItem'><Link className='walletsTableButton' to={`/depositDetails/${m.id}`}>View Details</Link></td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/depositsMain.tsx